import "@hotwired/turbo-rails";

import "bootstrap";

import "../controllers";

const THEME_STORAGE_KEY = "measurehub-theme";

const readStoredTheme = () => {
  try {
    return window.localStorage.getItem(THEME_STORAGE_KEY);
  } catch (error) {
    return null;
  }
};

const storeTheme = (theme) => {
  try {
    window.localStorage.setItem(THEME_STORAGE_KEY, theme);
  } catch (error) {}
};

const sanitizeTheme = (value) =>
  value === "dark" || value === "light" ? value : null;

const prefersDarkMode = () =>
  typeof window !== "undefined" &&
  window.matchMedia &&
  window.matchMedia("(prefers-color-scheme: dark)").matches;

const updateThemeToggleUI = (theme) => {
  const toggle = document.querySelector("[data-theme-toggle]");
  const icon = document.querySelector("[data-theme-toggle-icon]");
  const isDark = theme === "dark";

  document.querySelectorAll("[data-theme-toggle-label]").forEach((label) => {
    label.textContent = isDark ? "Light mode" : "Dark mode";
  });

  if (toggle) {
    toggle.setAttribute("aria-pressed", isDark ? "true" : "false");
    toggle.setAttribute(
      "aria-label",
      isDark ? "Switch to light mode" : "Switch to dark mode"
    );
  }

  if (icon) {
    icon.textContent = isDark ? "☀️" : "🌙";
  }
};

const applyTheme = (theme) => {
  const isDark = theme === "dark";
  document.documentElement.classList.toggle("dark-mode", isDark);
  updateThemeToggleUI(theme);
};

const initThemeToggle = () => {
  const storedTheme = sanitizeTheme(readStoredTheme());
  const initialTheme = storedTheme || (prefersDarkMode() ? "dark" : "light");

  applyTheme(initialTheme);

  const toggle = document.querySelector("[data-theme-toggle]");
  if (!toggle) {
    return;
  }

  if (toggle.dataset.themeToggleInitialized === "true") {
    return;
  }

  toggle.dataset.themeToggleInitialized = "true";

  toggle.addEventListener("click", () => {
    const isDark = document.documentElement.classList.contains("dark-mode");
    const nextTheme = isDark ? "light" : "dark";
    applyTheme(nextTheme);
    storeTheme(nextTheme);
  });

  const mediaQuery = window.matchMedia
    ? window.matchMedia("(prefers-color-scheme: dark)")
    : null;

  if (!mediaQuery) {
    return;
  }

  const handleChange = (event) => {
    if (sanitizeTheme(readStoredTheme())) {
      return;
    }

    applyTheme(event.matches ? "dark" : "light");
  };

  if (mediaQuery.addEventListener) {
    mediaQuery.addEventListener("change", handleChange);
  } else if (mediaQuery.addListener) {
    mediaQuery.addListener(handleChange);
  }
};

const fadeOutFlash = () => {
  document.querySelectorAll(".flash-alert").forEach((el) => {
    el.style.transition = "opacity 600ms ease";
    el.style.opacity = "0";
    setTimeout(() => el.remove(), 600);
  });
};

const onPageLoad = () => {
  initThemeToggle();
  setTimeout(fadeOutFlash, 3000);
};

document.addEventListener("turbo:load", onPageLoad);
